/**
 * Módulo do componente Cobranca List (cobranca-list)
 */
(function(){
	angular
		.module('cobrancaListModule', []);
})();